const comments = [
    {
        id: 1,
        avatar: require("@/assets/images/photo/photo-0.webp"),
        phoneNumber: "186577*****",
        comment: "交通方便，基本上是附近最好的酒店了。客房服务态度很好。",
        likes: 10
    },
    {
        id: 2,
        avatar: require("@/assets/images/photo/photo-1.webp"),
        phoneNumber: "185147*****",
        comment: " 因为下飞机比较晚所以选了距离机场比较近的宝利来酒店，店里设施很好，很多细节和设施很周到。很干净，早餐数量和质量 也都可以，入住期间正好是生日，晚上回房间后，发现桌上有酒店送的蛋糕盒祝福卡片。感觉很温馨。",
        likes: 25
    }, {
        id: 3,
        avatar: require("@/assets/images/photo/photo-2.webp"),
        phoneNumber: "133331*****",
        comment: "酒店位置特别方便去市区都很近，服务也超级nice，特别是有一个齐刘海的小姐姐很热心的帮忙提前查询订单安排入住，让赶了一夜路的我们尽快休息，超棒～",
        likes: 24
    }, {
        id: 4,
        avatar: require("@/assets/images/photo/photo-3.webp"),
        phoneNumber: "188541*****",
        comment: "酒店设施齐全，房间卫生干净，办理入住时前台还升级了套房，下次还会再来入住。",
        likes: 12
    }, {
        id: 5,
        avatar: require("@/assets/images/photo/photo-4.webp"),
        phoneNumber: "180214*****",
        comment: "很满意，在这个地段,去城隍庙吃小吃都非常方便。 环境：干净整洁。大厅还有设置公共办公场所。简易健身房和洗衣室。  服务：态度非",
        likes: 5
    }, {
        id: 6,
        avatar: require("@/assets/images/photo/photo-5.webp"),
        phoneNumber: "185214*****",
        comment: "酒店的位置交通很方便。一点都不吵。配置和环境都是极好的。服务员还送了两颗金芙，真是太有爱了。还会继续入住。",
        likes: 42
    }, {
        id: 7,
        avatar: require("@/assets/images/photo/photo-6.webp"),
        phoneNumber: "137584*****",
        comment: "来房间干净整洁，床也特别舒服，前台的小哥哥贼帅，小姐姐特别温柔。整体环境都很好，好评！",
        likes:5
    }, {
        id: 8,
        avatar: require("@/assets/images/photo/photo-8.webp"),
        phoneNumber: "178544*****",
        comment: "喜欢这里的设计 也特别安静 楼下的小鸟特别可爱 地理位置也不错 服务到位 性价比高 朋友都说好 值得再次预定",
        likes: 4
    }, {
        id: 9,
        avatar: require("@/assets/images/photo/photo-9.webp"),
        phoneNumber: "138454*****",
        comment: "非常愉快的一次旅行，地铁出行很安全，酒店服务特别好",
        likes: 2
    }, {
        id: 10,
        avatar: require("@/assets/images/photo/photo-10.webp"),
        phoneNumber: "136547*****",
        comment: "酒店帮我升级了房型，非常不错的体验。周边环境好，配套设施也很好，房间内还有空气净化器。大堂也有机器人可以送外卖。 ",
        likes: 1
    }, {
        id: 11,
        avatar: require("@/assets/images/photo/photo-11.webp"),
        phoneNumber: "131411*****",
        comment: "整体体验很不错，服务很到位，禅意的设计风格，很喜欢，还会再来！",
        likes: 4
    }, {
        id: 12,
        avatar: require("@/assets/images/photo/photo-12.webp"),
        phoneNumber: "133454*****",
        comment: "酒店环境雅致安静，服务态度热情，早餐尤其丰富可口👍👍下次来还选择住这里",
        likes: 9
    }, {
        id: 13,
        avatar: require("@/assets/images/photo/photo-13.webp"),
        phoneNumber: "154554*****",
        comment: "早餐不错，前台与餐厅的服务都很热情，房间干净。",
        likes: 7
    }, {
        id: 14,
        avatar: require("@/assets/images/photo/photo-14.webp"),
        phoneNumber: "175845*****",
        comment: "很安静，能很好的休息，房间里面的设施与网上说的一致，非常棒",
        likes: 6
    }, {
        id: 15,
        avatar: require("@/assets/images/photo/photo-15.webp"),
        phoneNumber: "134574*****",
        comment: "设施：非常好，酒店很新设施完善。 卫生：房间整洁干净。 环境：周边有地铁很方便，楼下饭店也非常多，临街但是并不吵。 服务：很热情",
        likes: 14
    }, {
        id: 16,
        avatar: require("@/assets/images/photo/photo-16.webp"),
        phoneNumber: "156321*****",
        comment: "设施：齐全 卫生：很干净 服务：特别不错 外卖会帮忙送到房间 有求必应",
        likes: 3
    }, {
        id: 17,
        avatar: require("@/assets/images/photo/photo-17.webp"),
        phoneNumber: "165544*****",
        comment: "房间舒适！酒店位置离地铁口很近！ 半自助早餐味道很不错～服务nicenice",
        likes:7
    }, {
        id: 18,
        avatar: require("@/assets/images/photo/photo-18.webp"),
        phoneNumber: "178451*****",
        comment: "酒店中式风格装修，房间升级了，安静。非常实用的是浴室门口有个晒衣服的架子，难得的很。服务周到认真，闹中取静的地方",
        likes: 8
    }, {
        id: 19,
        avatar: require("@/assets/images/photo/photo-19.webp"),
        phoneNumber: "138821*****",
        comment: "设施完善，非常干净，给我一种优雅的高级感，早餐的食材新鲜丰富",
        likes: 9
    }, {
        id: 20,
        avatar: require("@/assets/images/photo/photo-20.webp"),
        phoneNumber: "189565*****",
        comment: "酒店设计风格很好，房间干净，前台服务热情，每个小姑娘都很贴心。",
        likes: 11
    }, {
        id: 21,
        avatar: require("@/assets/images/photo/photo-21.webp"),
        phoneNumber: "186987*****",
        comment: "性价比超级高的酒店，新中式的风格，服务周到，房间很宽敞也很干净，前台小姐姐都很热情，退房忘了东西小姐姐还帮我免费寄回来，特别感谢",
        likes: 23
    }, {
        id: 22,
        avatar: require("@/assets/images/photo/photo-22.webp"),
        phoneNumber: "178124*****",
        comment: "住的很舒服，干净整洁，很安静。下次有机会还住这！前台也很贴心",
        likes: 12
    }, {
        id: 23,
        avatar: require("@/assets/images/photo/photo-23.webp"),
        phoneNumber: "132654*****",
        comment: "服务非常到位的酒店，房间很大，打扫卫生的阿姨和门口保安都非常nice很有礼貌、前台礼宾经理看到我在扇风直接递上了水",
        likes: 42
    }, {
        id: 24,
        avatar: require("@/assets/images/photo/photo-24.webp"),
        phoneNumber: "150101*****",
        comment: "酒店环境特别好，装修高级干净，晚上睡觉很安静，刚来下了几天雨，有点潮湿，酒店还可以提供除湿机放在房间里，服务特别周到，是性价比非常高的酒店",
        likes: 11
    },

];

export {
    comments

}


